import { createReducer } from '@reduxjs/toolkit';

import {
  CONTRACT_AUTHENTICATION_INITIALIZE,
  CONTRACT_AUTHENTICATION_MESSAGE_READ,
} from '@app/store/actionTypes';
import { fetchMessageFromRequester } from '@app/store/contract-authentication/actions';

type ContractAuthenticationIsMessageReadState = boolean;

const initialState: ContractAuthenticationIsMessageReadState = false;

const reducer = createReducer(initialState, (builder) =>
  builder
    .addCase(CONTRACT_AUTHENTICATION_INITIALIZE, () => initialState)
    .addCase(fetchMessageFromRequester.pending, () => initialState)
    .addCase(fetchMessageFromRequester.fulfilled, (_, action) => !action.payload)
    .addCase(CONTRACT_AUTHENTICATION_MESSAGE_READ, () => true)
);

export default reducer;
